<template>
    <v-app id="app" :class="{ 'app-transparent': $route.name === 'LiveData' }">
        <div v-if="$route.name === 'LiveData'">
            <router-view />
        </div>
        <v-container v-else class="bg mx-0 px-0" :class="$vuetify.breakpoint.mobile ? 'mb-15 mt-0' : 'my-0 py-0'" fluid :style="`{background: url(${getBackground}) !important; }`">
            <v-banner
                v-if="device !== 'web'"
                height="150px"
                color="white"
                class="my-0 py-0"
                sticky
                style="z-index: 1000000;"
            >
                <v-row justify="center" align="center" class="py-0 my-0">
                    <v-col cols="12" align="center" class="py-0 my-0">
                        <span>
                            <v-icon style="cursor: pointer;" @click="device='web'">mdi-close</v-icon>
                        </span>
                        <span class="ml-5">Για την καλύτερη εμπειρία, κατεβάστε την εφαρμογή μας για κινητά!</span>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-img
                            v-if="device === 'android'"
                            height="53px"
                            width="160px"
                            style="cursor: pointer;"
                            :src="require('@/assets/google_play.png')"
                            @click="openSocial('google_play')"
                        />
                        <v-img
                            v-else-if="device === 'ios'"
                            height="53px"
                            width="151px"
                            style="cursor: pointer;"
                            :src="require('@/assets/app_store.svg')"
                            @click="openSocial('app_store')"
                        />
                    </v-col>
                </v-row>
            </v-banner>
            <section-title v-if="$vuetify.breakpoint.mobile" :title="typeof $route.meta === 'string' ? $route.meta : '' " :class="$vuetify.breakpoint.mobile && $route.name !== 'Team' && $route.name !== 'Match' && $route.name !== 'FacebookPostMatch' ? '' : ''" />
            <nav-bar v-if="$route.name !== 'FacebookPostMatch'" :class="$vuetify.breakpoint.mobile || $route.name === 'Team' || $route.name === 'Match' || $route.name === 'FacebookPostMatch' ? '' : 'pb-15'" />
            <results-carousel v-if="false" :matches="matches" class="my-0 py-0" />
            <v-row no-gutters :class="$vuetify.breakpoint.mobile || $route.name === 'Team' || $route.name === 'Match' || $route.name === 'FacebookPostMatch' ? '' : 'px-1'" class="py-0 my-0">
                <!-- <aegean-ball v-if="!($route.name === 'Team' || $route.name === 'Match')"/> -->
                <v-col cols="12" class="py-0 my-0" :class="$vuetify.breakpoint.mobile || $route.name === 'Team' || $route.name === 'Match' || $route.name === 'FacebookPostMatch' ? '' : 'px-0'">
                    <router-view :class="$vuetify.breakpoint.mobile || $route.name === 'Team' || $route.name === 'Match' || $route.name === 'FacebookPostMatch' ? '' : 'px-1'" />
                </v-col>
            </v-row>
        </v-container>
        <custom-footer v-if="!$vuetify.breakpoint.mobile && $route.name !== 'LiveData'" class="mt-16" />
        <v-btn
            v-show="fab"
            v-scroll="onScroll"
            fab
            dark
            fixed
            :bottom="!$vuetify.breakpoint.mobile"
            :style="$vuetify.breakpoint.mobile ? 'bottom: 80px; right: 5px;' : 'bottom: 100px; right: 25px;'"
            :right="!$vuetify.breakpoint.mobile"
            :small="$vuetify.breakpoint.mobile"
            color="white"
            class="custom-teal"
            style="z-index: 14;"
            @click="toTop"
        >
            <v-icon :large="!$vuetify.breakpoint.mobile" color="white">mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import NavBar from '@/components/NavBar.vue'
    import CustomFooter from '@/components/Footer.vue'
    import SectionTitle from '@/components/Title'
    import ResultsCarousel from '@/components/ResultsCarousel.vue'

    export default {
        name: 'App',
        components: {
            NavBar,
            SectionTitle,
            CustomFooter,
            ResultsCarousel
        },
        data() {
            return {
                fab: false,
                device: 'web', // Default to web, will be updated in mounted(),
                matches: []
            }
        },
        watch: {
            $route() {
                document.title = `${this.$route.meta} | EKA BASKET`
                this.syncTransparentBody()
            }
        },
        mounted() {
            this.syncTransparentBody()
            if (this.isNativeApp()) {
                // You can also check platform:
                const ua = navigator.userAgent || navigator.vendor || window.opera
                if (/android/i.test(ua)) {
                    this.device = 'android'
                } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
                    this.device = 'ios'
                }
            } else {
                this.device = 'web'
            }
        },
        created() {
            this.ensureConfig()
        },
        methods: {
            ensureConfig() {
                return this.$store.dispatch('ensureConfig')
            },
            isNativeApp() {
                // Cordova injects window.cordova; Capacitor injects window.Capacitor
                return !!window.cordova || !!window.Capacitor
            },
            getBackground() {
                return require(this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)])
            },
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            syncTransparentBody() {
                const live = this.$route?.name === 'LiveData'
                document.body.classList.toggle('body-transparent', !!live)
            }
        }
    }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Squada+One&display=swap');

.v-card {
    color: white;
    background: #232323;
}

.v-slide-group__prev {
    display: none !important;
}

.v-tab {
    color: white !important;
}

.v-tab--active {
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.custom-teal {
    background: #e3f905;
}

.custom-teal-text {
    color: #e3f905;
}

#app {
    font-family: Squada One, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.bg {
    /* position: absolute; */
    background: white;
    background-size: cover;
    background-repeat: no-repeat;

    /* background: rgb(255,162,0);
    background: linear-gradient(90deg, rgba(255,162,0,1) 0%, rgba(240,240,242,1) 50%); */
    width: 100%;
    height: 100%;
}

@media only screen and (max-width: 1000px) {
    .bg {
        background: white top 65px right;
        background-size: contain;
        background-repeat: no-repeat;
    }
}

.v-data-table {
    font-family: Arial, sans-serif !important;
    font-weight: 400;
}

thead {
    white-space: nowrap;
}

.secondary-font {
    font-family: Arial, sans-serif !important;
    color: white;
    font-weight: 700;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:horizontal {
    border-radius: 10px;
}

.clickable {
    cursor: pointer !important;
}

table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
    position: sticky !important;
    left: 0;
    background: #232323;
}

.app-transparent,
.app-transparent .v-application,
.app-transparent .v-application--wrap,
.app-transparent #app {
    background: transparent !important;
    background-color: transparent !important;
}

/* Also clear page background when LiveData */
.body-transparent {
    background: transparent !important;
    background-color: transparent !important;
}
</style>
